export default __webpack_public_path__ + "images/0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48.png";